import Vue from 'vue'
import VueRouter from 'vue-router'
import home from './home'
import doc from './doc'
import company from './company'
import companyCore from './company-core'
import sys from './sys'
import ticket  from "./ticket";
import auth from './auth'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  // base: 'open',
  routes: [
    ...company,
    ...home,
    ...doc,
    ...companyCore,
    ...sys,
    ...ticket,
    ...auth,
    {
      path: '/agreement/developer-service',
      name: 'developerService',
      component: () => import(/* webpackChunkName: "developerService" */ '../views/agreement/developer-service')
    },
    {
      path: '/message',
      name: 'message',
      component: () => import(/* webpackChunkName: "message" */ '../views/message/index')
    },
    {
      path: '/agreement/privacy-policy',
      name: 'privacyPolicy',
      component: () => import(/* webpackChunkName: "privacyPolicy" */ '../views/agreement/privacy-policy')
    },
    {
      path: '/agreement/management-protocol',
      name: 'managementProtocol',
      component: () => import(/* webpackChunkName: "developerService" */ '../views/agreement/management-protocol')
    },
    {
      path: '/tool',
      name: 'Tool',
      component: () => import(/* webpackChunkName: "Tool" */ '../views/tool/index')
    },
    {
      path: '*',
      redirect: {name: 'home'}
    }
  ],
  scrollBehavior (to, from, saved) {
    if (saved) return saved
    return {x: 0, y: 0}
  }
})

